module.exports = __webpack_public_path__ + "img/img-1.3275651f.png";